import FormInputWrapper from './FormInputWrapper';

export default FormInputWrapper;
